import * as React from 'react';
import MUIDataTable, { Responsive } from 'mui-datatables';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CloseIcon from '../../../assets/close';
import debitIcon from '../../../assets/debitIcon';
import manualEdit from '../../../assets/images/manual-edit.png';
import Modal from 'src/components/common/Modal';
import './SelectedDebitInvoice.scss';
import invoiceServiceInstance from 'src/services/invoice/InvoiceService';
import theme from '../../../themes/theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import i18n from 'src/translation/i18n';

function SelectedDebitInvoiceTable(props: any) {
  const [responsive, setResponsive] = React.useState('vertical');
  const [tableBodyHeight, setTableBodyHeight] = React.useState('400px');
  const [tableBodyMaxHeight, setTableBodyMaxHeight] = React.useState('');
  const [transitionTime, setTransitionTime] = React.useState(300);
  const [shortpaypopup, setShortpaypopup] = React.useState(false);
  const [shortpaydebitdata, setShortpaydebitdata] = React.useState([]);
  const [reason, setReason] = React.useState('');
  const [onSelectRowCheckData, setOnSelectRowCheckData] = React.useState(
    props.slelectedDataInvoices
  );
  const [shortpaydata, setShortpaydata] = React.useState([]);
  const [selectedshortpayindex, setSelectedshortpayindex] = React.useState(
    null
  );
  const [validationMessage, updateValidationMsg] = React.useState(null);
  const [valError, setValError] = React.useState(false);
  const [selectedpaydata, setSelectedpaydata] = React.useState([]);
  const [amount, setAmount] = React.useState<number>();
  const [rowscount, setRowscount] = React.useState([]);
  const [reasonIndex, setReasonIndex] = React.useState([]);
  const [slelectedDataInvoices, setSlelectedDataInvoices] = React.useState(
    props.slelectedDataInvoices
  );
  const [sortOption, setSortOption] = React.useState({
    name: 'invoiceDate',
    direction: 'asc'
  });
  const columns = [
    {
      label: `${i18n.t('invoices.invoiceNum')}`,
      name: 'invoiceNumber',
      options: {
        filter: false,
        customBodyRender: (value: any, tablemeta: any) => {
          return (
            <label>
              {value}
              <img className="icon-position" src={debitIcon} />
            </label>
          );
        }
      }
    },
    { label: `${i18n.t('invoices.invoiceDate')}`, name: 'invoiceDate' },
    {
      label: `${i18n.t('invoices.amountOwed')}`,
      name: 'totalAmount',
      options: {
        filter: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {parseFloat(value).toFixed(2)}</label>;
          return <label>{currencyFormatter(value)}</label>;
        }
      }
    },
    // { label: 'Payment.Amt', name: 'paymentAmount' },

    {
      label: `${i18n.t('invoices.paymentAmt')}`,
      name: 'paymentAmount',
      options: {
        filter: false,
        empty: true,
        sort: false,
        customBodyRender: (value: any, tablemeta: any) => {
          return (
            // <span
            //   className="remainig-amount-link"
            //   onClick={() => shortPay(tablemeta, value)}
            // >
            //   {value}
            // </span>
            <label>
              {currencyFormatter(value)}
              <img
                className="icon-position short-pay-edit"
                title="Short pay"
                src={manualEdit}
                onClick={() => shortPay(tablemeta, value)}
              />
            </label>
          );
        }
      }
    },
    {
      label: `${i18n.t('invoices.payRem')}`,
      name: 'remainingAmount',
      options: {
        sort: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {parseFloat(value).toFixed(2)}</label>;
          return <label>{currencyFormatter(value)}</label>;
        }
      }
    },
    {
      label: 'transactionId',
      name: 'transactionId',
      options: { display: false }
    }
  ];
  const shortPay = (tablemeta: any, value: any) => {
    const isChecked =
      onSelectRowCheckData.filter(
        (val: any) => val.invoiceNumber === tablemeta?.rowData[0]
      ).length > 0;
    if (isChecked || props.continue) {
      let debitdata: number[] = [];
      if (reasonIndex && reasonIndex.length > 0) {
        const indexVal = reasonIndex.findIndex(
          (val: any) => val.invNum === tablemeta?.rowData[5]
        );
        if (indexVal > -1) {
          setReason(reasonIndex[indexVal].message);
          setAmount(Math.abs(value));
        } else {
          setReason('');
          setAmount(null);
        }
      }
      setShortpaypopup(true);
      debitdata = tablemeta.rowData;
      setShortpaydebitdata(debitdata);
      setSelectedshortpayindex(tablemeta);
      props.isdebiteditdata(debitdata);
    } else {
      props.handleShortPayError();
    }
  };
  const getTargetpaymentsData = () => {
    const appliedCreditInvoices: any[] = [];

    creditdatainvoicess.forEach((num: any) => {
      appliedCreditInvoices.push({
        orderNumber: num.orderNumber,
        paymentAmount: num.remainingAmount,
        reasonRemainingBalance: 'Test',
        transactionId: num.transactionId
      });
    });
    props.selectedInvoices.forEach((num: any) => {
      appliedCreditInvoices.push({
        orderNumber: num.orderNumber,
        paymentAmount: num.remainingAmount,
        reasonRemainingBalance: 'Test',
        transactionId: num.transactionId
      });
    });
    return appliedCreditInvoices;
  };
  function isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }
  const savebtn = () => {
    if (
      amount != null &&
      amount !== 0 &&
      amount !== undefined &&
      !isNaN(amount) &&
      amount === shortpaydebitdata[2]
    ) {
      setReason('');
      updateValidationMsg('');
      shortPayValueSet();
    } else if (
      reason === '' ||
      reason == null ||
      amount == null ||
      amount === 0 ||
      amount === undefined ||
      isNaN(amount)
    ) {
      updateValidationMsg(i18n.t('invoices.message5'));
      setValError(true);
    } else if (amount > shortpaydebitdata[2]) {
      updateValidationMsg(i18n.t('invoices.message6'));
    } else {
      shortPayValueSet();
    }
  };
  const shortPayValueSet = () => {
    updateValidationMsg('');
    // set table value
    const modifiedTableData = slelectedDataInvoices.map(
      (item: any, index: any) => {
        if (selectedshortpayindex.rowData[5] === item.transactionId) {
          return {
            ...item,
            paymentAmount: amount / 1,
            remainingAmount: (item.totalAmount / 1 - amount / 1).toFixed(2),
            reasonText: reason
          };
        }
        return item;
      }
    );
    const invoiceRowData = selectedshortpayindex.rowData[5];
    const findIndexVal = reasonIndex.findIndex(
      (val: any) => val.invNum === invoiceRowData
    );
    if (findIndexVal > -1) {
      const newReasonIndex = [...reasonIndex];
      newReasonIndex[findIndexVal].message = reason;
      setReasonIndex(newReasonIndex);
    } else {
      const objVal: any = {};
      objVal.invNum = invoiceRowData;
      objVal.message = reason;
      reasonIndex.push(objVal);
      setReasonIndex(reasonIndex);
    }
    setSlelectedDataInvoices(modifiedTableData);
    props.isUpdateAmount(modifiedTableData);
    setShortpaypopup(false);
    // setReason('');
    // setAmount(null);
  };
  const changeSetAmount = (amt: number) => {
    const chkAmt = amt < 0 ? -1 * (amt / 1) : amt;
    if (chkAmt === shortpaydebitdata[2]) {
      setReason('');
      updateValidationMsg('');
    }
    setAmount(chkAmt);
  };
  const clickclose = () => {
    setShortpaypopup(false);
  };
  const { getselectCredit } = props;
  const { totalCreditmanual } = props;
  const { creditdatainvoicess } = props;
  const { totalDebitmanual } = props;
  const { selectedinvoiceData } = props;
  const { invoiceData } = props;
  const { selectCreditInvoices } = props;

  React.useEffect(() => {
    const datChecked = slelectedDataInvoices.map(
      (item: any, index: any) => index
    );
    if (rowscount.length === 0) {
      setRowscount(datChecked);
    }
    if (datChecked.length > 0) {
      // props.isChecked(datChecked, slelectedDataInvoices);
    }
  }, [slelectedDataInvoices]);

  React.useEffect(() => {
    props.removeViewColumnBtn(false);
  }, []);

  const onRowSelectionChange = (
    currentRowsSelected: any,
    allRowsSelected: any,
    rowsSelectedpath: any
  ) => {
    const newSelectedDataInvoice: any = [];

    rowsSelectedpath.forEach((val: any) => {
      newSelectedDataInvoice.push(slelectedDataInvoices[val]);
    });
    setOnSelectRowCheckData(newSelectedDataInvoice);
    props.isChecked(currentRowsSelected, newSelectedDataInvoice);
    // const indexVal = currentRowsSelected[0].index;
    // slelectedDataInvoices.splice(slelectedDataInvoices[indexVal], 1);
    setRowscount(rowsSelectedpath);
    // setSlelectedDataInvoices(slelectedDataInvoices);
  };

  const onColumnSortChange = (name: string, direction: string) => {
    setSortOption({ name, direction });
  };

  const options = {
    filter: false,
    search: false,
    download: false,
    pagination: false,
    print: false,
    rowsSelected: rowscount,
    fixedHeader: false,
    responsive: 'standard' as Responsive,
    draggableColumns: {
      enabled: true,
      transitionTime
    },
    onRowSelectionChange,
    selectableRows: false as any,
    onColumnSortChange,
    sort: true,
    sortOrder: {
      name: sortOption.name,
      direction: sortOption.direction as any
    }
  };

  const data = [];

  return (
    <div className="manual-debit-table">
      <React.Fragment>
        <MuiThemeProvider theme={theme}>
          <MUIDataTable
            title={''}
            data={slelectedDataInvoices}
            columns={columns}
            options={options}
          />
        </MuiThemeProvider>
        {shortpaypopup ? (
          <div>
            <Modal handleCloseModal={() => console.log('Modal closed')}>
              <div className="short-pay">
                <div className="d-flex justify-space-bw">
                  <div className="modal-label">
                    {i18n.t('invoices.shortPay')}
                  </div>
                  <div className="close-icon" onClick={clickclose}>
                    <img src={CloseIcon} />
                  </div>
                </div>
                <div className="modal-content">
                  <table className="width-table">
                    <tr>
                      <td>
                        <div className="invoice-label">
                          {i18n.t('invoices.invoiceNo')}
                        </div>
                        <div>{shortpaydebitdata[0]}</div>
                      </td>
                      <td>
                        <div className="invoice-label">
                          {i18n.t('invoices.invoiceDate')}
                        </div>
                        <div>{shortpaydebitdata[1]}</div>
                      </td>
                      <td>
                        <div className="invoice-label">
                          {i18n.t('invoices.TotalAmount')}
                        </div>
                        <div>{currencyFormatter(shortpaydebitdata[2])}</div>
                      </td>
                    </tr>
                  </table>
                  <div className="input-label">
                    {i18n.t('invoices.PaymentAmount')}
                  </div>

                  <div>
                    {' '}
                    <input
                      type="number"
                      name="name"
                      value={amount}
                      onChange={e =>
                        changeSetAmount(parseFloat(e.target.value))
                      }
                    />
                  </div>

                  <div className="input-label">{i18n.t('invoices.reason')}</div>
                  <div className="reason">
                    <input
                      type="text"
                      name="name"
                      value={reason}
                      onChange={e => setReason(e.target.value)}
                    />
                  </div>
                  <div className="rp-input--message">{validationMessage}</div>
                </div>

                <div className="text-align-center">
                  <button className="cancel-btn" onClick={clickclose}>
                    {i18n.t('common.cancel')}
                  </button>
                  <button className="ok-btn" onClick={savebtn}>
                    {i18n.t('common.save')}
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        ) : (
          ''
        )}
      </React.Fragment>
    </div>
  );
}
export default SelectedDebitInvoiceTable;
